import React, { FocusEvent } from 'react';

import AcInput from 'components/AcInput/AcInput';

interface IQuantityFormatNumberFieldProps {
  header: string;
  name: string;
  value: string;
  error: boolean;
  helperText: string;
  onFieldChange: (fieldPath: string, rawValue: string) => void;
  onBlur: (event: FocusEvent<HTMLElement>) => void;
}

export const QuantityFormatNumberField = ({
  header,
  name,
  value,
  error,
  helperText,
  onFieldChange,
  onBlur
}: IQuantityFormatNumberFieldProps): React.ReactElement => (
  <AcInput
    type="number"
    header={header}
    name={name}
    value={value}
    onChange={(event) => onFieldChange(name, event.target.value)}
    onBlur={onBlur}
    error={error}
    helperText={helperText}
  />
);
